import { render, staticRenderFns } from "./Imports_upload.vue?vue&type=template&id=63a1a8e5&scoped=true&lang=pug&"
import script from "./Imports_upload.vue?vue&type=script&lang=coffee&"
export * from "./Imports_upload.vue?vue&type=script&lang=coffee&"
import style0 from "./Imports_upload.vue?vue&type=style&index=0&id=63a1a8e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1a8e5",
  null
  
)

export default component.exports